"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6.652A3.65 3.65 0 0 1 6.652 3h6.696A3.65 3.65 0 0 1 17 6.652V8.48a.691.691 0 0 1-1.382 0v-.944H4.382v5.812a2.27 2.27 0 0 0 2.27 2.27H10A.691.691 0 0 1 10 17H6.652A3.65 3.65 0 0 1 3 13.348zm1.437-.497h11.126a2.27 2.27 0 0 0-2.215-1.773H6.652a2.27 2.27 0 0 0-2.215 1.773m3.596 6.663a.656.656 0 1 1-1.312 0 .656.656 0 0 1 1.312 0m-.656-2.16a.656.656 0 1 0 0-1.313.656.656 0 0 0 0 1.313",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.437 6.155a2.265 2.265 0 0 1 2.216-1.773h6.695a2.265 2.265 0 0 1 2.215 1.773zm2.94 6.332a.33.33 0 1 0 0 .662.33.33 0 0 0 0-.662m0-2.817a.331.331 0 1 0 0 .662.331.331 0 0 0 0-.662M6.652 3A3.65 3.65 0 0 0 3 6.652v6.696A3.65 3.65 0 0 0 6.652 17H10a.691.691 0 0 0 0-1.382H6.652a2.27 2.27 0 0 1-2.27-2.27V7.536h11.236v.944a.691.691 0 0 0 1.382 0V6.652A3.65 3.65 0 0 0 13.348 3zm.725 10.474a.656.656 0 1 0 0-1.312.656.656 0 0 0 0 1.312m.656-3.473a.656.656 0 1 1-1.312 0 .656.656 0 0 1 1.312 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.27 10.344c.288.25.318.687.068.975l-.431.496h2.872l-.431-.496a.691.691 0 0 1 1.043-.907l1.426 1.64a.69.69 0 0 1 0 .907l-1.426 1.64a.69.69 0 1 1-1.043-.906l.431-.496h-2.872l.43.496a.69.69 0 1 1-1.042.907l-1.426-1.64a.69.69 0 0 1 0-.907l1.426-1.64a.69.69 0 0 1 .975-.069",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TimescaleIcon20.js.map